let oemConfigMap = new Map();

export default oemConfigMap;



// WEBPACK FOOTER //
// ./src/config/oem_config_map.js